export enum UdfControlType {
    CheckBox = 'Check Box',
    TextBox = 'Textbox',
    Header = 'Header',
    Dropdown = 'Dropdown',
    Html = 'HTML'
}



